<template>
  <v-col cols="12" :xl="chartWidth">
    <v-card flat elevation="5" height="100%">
      <v-lazy
          v-model="lazyActive"
          min-height="300"
          :options="{
          threshold: 0.1,
        }"
          transition="fade-transition"
      >
        <Charts :option="totalReportChart"/>
      </v-lazy>
    </v-card>
  </v-col>
</template>

<script>

// import Charts from "@/components/Charts.vue";
import {mapGetters, mapMutations} from "vuex";
// import { router } from "@/plugins/router";
export default {
  props: {
    cardInfoItem: Array,
    chartInfoState: Boolean,
  },
  components: {
    // Charts,
    Charts: () => import("@/components/Charts.vue"),
  },
  computed: {
    ...mapGetters("overview", [
      "getDateRange",
      "getTotalReport",
      "getTotalReportHelpIcon",
      "getDataSources",
    ]),
    chartWidth() {
      //資料範圍 15 天以上 col=12
      const series = this.getTotalReport.series || [];
      const dataRange = this.getDateRange;
      return series.length > 0 && dataRange.length > 15 ? "12" : "6";
    },
    totalReportChart() {
      //總瀏覽圖
      const option = this.reportData;
      const report = this.getTotalReport; //vuex
      const dateRange = this.getDateRange; //vuex
      option.xAxis.categories = dateRange; //vuex
      option.helpIcon = this.getTotalReportHelpIcon;
      option.title.text = report.chartTitle;
      option.subtitle.text = `${dateRange[0]} ~ ${dateRange.slice(-1)}`;
      option.series = report.series;
      // option.plotOptions.series.point.events = {
      // click: ({ point }) => {
      //   const {
      //     // category,
      //     series: {
      //       userOptions: { name },
      //     },
      //   } = point;
      // console.log("category",category)
      // const dateIndex = this.getDateRange.indexOf(category);
      // const sourceIndex = this.getDataSources.indexOf(name);
      // if (sourceIndex > -1) {
      // router.push("/customanalysis").catch((err) => console.log(err));
      // this.updateSingledayData({ sourceIndex, dateIndex });
      // }
      // },
      // };
      return option;
    },
  },
  methods: {
    // ...mapActions("overview", ["updateSingledayData"]),
    ...mapMutations("overview", ["setTotalReport"]),
    getOption(value) {
      this.setTotalReport(value);
      const option = JSON.parse(JSON.stringify(this.reportData));
      const report = this.getTotalReport; //vuex
      const dateRange = this.getDateRange; //vuex
      option.xAxis.categories = dateRange; //vuex
      option.helpIcon = this.getTotalReportHelpIcon;
      option.title.text = report.chartTitle;
      option.subtitle.text = `${dateRange[0]} ~ ${dateRange.slice(-1)}`;
      option.series = report.series;
      return option;
    }
  },
  watch: {
    chartInfoState() {
      if (this.chartInfoState === true) {
        this.$emit("addChartInfo", {
          data: this.getOption(this.cardInfoItem[0]),
          id: "totalReportPageViews"
        });
        this.$emit("addChartInfo", {
          data: this.getOption(this.cardInfoItem[1]),
          id: "totalReportUniqueVisitors"
        });
        this.$emit("addChartInfo", {
          data: this.getOption(this.cardInfoItem[2]),
          id: "totalReportAvgPageViews"
        });
        this.$emit("addChartInfo", {
          data: this.getOption(this.cardInfoItem[3]),
          id: "totalReportAvgPageTime"
        });
      }
    },
  },
  data: () => ({
    lazyActive: false,
    reportData: {
      chart: {
        zoomType: "x",
        resetZoomButton: {
          relativeTo: "chart",
        },
      },
      title: {
        text: "總瀏覽數趨勢圖",
      },
      subtitle: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      xAxis: {
        // min: 0,
        // max: 20,
        labels: {
          // rotation:25,
          formatter() {
            return this.value.substring(5);
          },
        },
        events: {
          afterSetExtremes() {
            // 依 zoom in 日期範圍改變副標
            const axes = this.chart.axes[0];
            let {min, max} = axes.getExtremes();
            let minDate = axes.categories[Math.round(min)];
            let maxDate = axes.categories[Math.round(max)];
            this.chart.setTitle(null, {
              text: minDate && maxDate ? `${minDate} ~ ${maxDate}` : "",
            });
          },
        },
        categories: [],
      },
      yAxis: {
        min: 0,
        title: {
          text: "",
        },
        plotLines: [
          {
            value: 0,
            width: 1,
            color: "#808080",
          },
        ],
      },
      legend: {
        layout: "horizontal",
        align: "center",
        verticalAlign: "bottom",
        borderWidth: 0,
      },
      series: [],
      plotOptions: {
        series: {
          cursor: "pointer",
          point: {},
          animation: {
            duration: 600,
          },
        },
      },
      exporting: {
        relativeTo: "chart",
        buttons: {
          contextButton: {
            //改button樣式
            symbol: "download",
            menuItems: ["downloadCSV"],
          },
        },
      },

      // helpIcon: {
      //   annotation: "網頁的瀏覽數加總。重複瀏覽同一個網頁也計算在內。",
      //   enabled: true,
      // }
    },

  }),
};

</script>
